import styled from '@emotion/styled';
import { Button, colors, Icon } from '@ui-components/neo.tax';
import { Menu as AriaMenu, MenuItem as AriaMenuItem } from 'ariakit';

import { ZIndex } from '@neo.tax/shared';

export const StyledMenuButton = styled(Button)({
  margin: 0,
});

export const ActionsMenu = styled(AriaMenu)({
  minWidth: 248,
  padding: 4,
  borderRadius: 10,
  backgroundColor: colors.white,
  border: `1px solid ${colors.gray[200]}`,
  boxShadow:
    '0 0 0 1px rgba(16, 24, 40, 0.04), 0 12px 24px -8px rgba(16, 24, 40, 0.16), 0 4px 8px -4px rgba(16, 24, 40, 0.08)',
  outline: 'none',
  zIndex: ZIndex.MODAL,
});

export const ActionsMenuItem = styled(AriaMenuItem)({
  display: 'flex',
  alignItems: 'flex-start',
  gap: 10,
  padding: '10px 12px',
  borderRadius: 6,
  color: colors.gray[800],
  fontSize: '0.875rem',
  lineHeight: '1.25rem',
  fontWeight: 500,
  cursor: 'pointer',
  outline: 'none',
  userSelect: 'none',
  textAlign: 'left',
  transition: 'background-color 120ms ease, color 120ms ease',

  '&[data-active-item]:not([aria-disabled="true"])': {
    backgroundColor: colors.primary[50],
    color: colors.primary[800],
  },

  '&:focus-visible': {
    boxShadow: `0 0 0 2px ${colors.primary[200]}`,
  },

  '&[aria-disabled="true"]': {
    cursor: 'not-allowed',
    color: colors.gray[400],
  },
});

export const ActionsMenuItemIcon = styled(Icon)({
  color: colors.gray[500],
  flexShrink: 0,
  marginTop: 2,
  transition: 'color 120ms ease',

  [`${ActionsMenuItem}[data-active-item]:not([aria-disabled="true"]) &`]: {
    color: colors.primary[600],
  },
  [`${ActionsMenuItem}[aria-disabled="true"] &`]: {
    color: colors.gray[300],
  },
});

export const ActionsMenuItemText = styled.span({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minWidth: 0,
  gap: 2,
});

export const ActionsMenuItemLabel = styled.span({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const ActionsMenuItemHint = styled.span({
  fontSize: '0.75rem',
  lineHeight: '1rem',
  fontWeight: 400,
  color: colors.gray[400],
});
